










































import {
  Component, Vue, PropSync, Prop,
} from 'vue-property-decorator';
import Overlay from '@/components/Overlay/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';

@Component({
  components: {
    Overlay,
    Textfield,
    PrimaryButton,
    TextButton,
  },
})
export default class ConfigurationModal extends Vue {
  @PropSync('dialog', {}) dialogSync!: boolean;

  @PropSync('configurationValue', {}) configSync!: any;

  @Prop({}) documentHeadline!: string;

  @Prop({}) loading!: boolean;

  @Prop({}) label!: string;

  @Prop({ default: false }) isEditMode!: boolean;

  get submitLabel(): string {
    return this.isEditMode ? 'Save' : 'Add';
  }

  public close() {
    this.$emit('cancel');
  }

  public add() {
    this.$emit('addConfig', this.configSync, this.label);
  }

  textFieldRules = [(v: any) => !!v || `${this.label} is required`];
}
